
import * as React from 'react';
import * as _ from 'lodash'
import moment from 'moment'


import config from '../../../constants/config';
import { Container, Spinner, OverlayTrigger, Image, Tooltip } from 'react-bootstrap';
import { randomId } from '../../../utils';
import images from '../../../constants/images';
import { UserT } from '../../../types/Users';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import Axios from 'axios'
import ContentLoader from 'react-content-loader';
import { JobT } from '../../../types/Job';
import { AxiosInstance } from '../../../utils/RequestMethods';
import { SeeByT } from '../../../types/SeeByT';
import LineItemSeeBy from '../../../components/LineItemSeeBy';




const Loader = (props) => (
  <ContentLoader
    viewBox="0 0 100 50"
    height={"100"}
    width={"50"}
    backgroundColor="transparent"
    {...props}
  >
    <circle cx="150" cy="86" r="8" />
    <circle cx="194" cy="86" r="8" />
    <circle cx="238" cy="86" r="8" />
  </ContentLoader>
);
export type ILineItemsSeeByProps = {
  job: JobT
  socket?: any
}


const LineItemsSeeBy: React.FC<ILineItemsSeeByProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const [currentJob, setCurrentJob] = React.useState(null)

  React.useEffect(() => {
    const ourRequest = Axios.CancelToken.source() // <-- 1st step
    if (!_.isEqual(currentJob, props.job)) {
      fetchData(ourRequest.token)
      setCurrentJob(props.job)
    }
    return () => {
      ourRequest.cancel() // <-- 3rd step
    }

  }, [props.job])

  React.useEffect(() => {
    const ourRequest = Axios.CancelToken.source() // <-- 1st step
    if (props.socket) {
      props.socket.on("update-jobs", (data) => {
        if (data?.data == props?.job?.id) {
          fetchData(ourRequest.token)
        }
      })
    }
    return () => {
      ourRequest.cancel()
    }
  }, [props.socket]);


  const fetchData = async (cancelToken) => {
    console.log("fetchJobSee->fetchData", props.job?.id)
    setIsLoading(true)
    // console.log("cancelToken->cancelToken", cancelToken)
    AxiosInstance.get(`${config.url.jobs}/${props.job.id}/see-by`).then((res) => {
      setIsLoading(false)
      if (res && res.data) {
        setItems(res.data)
      }
    }).catch((error) => {
      setIsLoading(false)
    })
  }



  if (isLoading) {
    return (
      <Container className="mt-5 text-center">
        {/* <Spinner animation="border" variant="info" /> */}
        Loading ...
        {/* <Loader /> */}
      </Container>
    )
  }

  return (
    //  <LoadingSpinner loading={isLoading} >

    <>
      {/* {isLoading && <span> Loading ...</span>} */}
      <div className="d-flex flex-row flex-wrap">
        {_.isArray(items) && items.map((item: SeeByT, index) => {
          return (
            <LineItemSeeBy key={index} item={item} index={index} />
          )
        })}
      </div>
    </>
    // {/* </LoadingSpinner> */}
  );
}
export default LineItemsSeeBy;
export { LineItemsSeeBy };
